var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import AdjustIcon from '@mui/icons-material/Adjust';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { t } from 'i18next';
import moment from "moment";
import { memo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AllEstimateUrl } from "../../api/url";
import { CrossIcon } from "../../assets/images";
import { MuiStack } from "../../components";
import StatusColor from "../../components/atoms/statusColor";
import { getByIdAPI } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { RUPEES_SYMBOL } from '../../constants';
var ServiceEstimateDrawer = function (props) {
    var _ref, _originalEstimate$Par, _originalEstimate$Lab;
    var parentModuleName = props.parentModuleName, onCrossClick = props.onCrossClick, onViewClick = props.onViewClick, estimateId = props.estimateId, Code = props.Code, jobCardId = props.jobCardId, onRevisedEstimateClick = props.onRevisedEstimateClick;
    var _a = useState(0), labourCost = _a[0], setLabourCost = _a[1];
    var _b = useState(0), partCost = _b[0], setPartCost = _b[1];
    var _c = useState(0), estimateCost = _c[0], setEstimateCost = _c[1];
    var _d = useState(''), status = _d[0], setStatus = _d[1];
    var _e = useState([]), originalEstimate = _e[0], setoriginalEstimate = _e[1];
    var _f = useState([]), revisedEstimates = _f[0], setRevisedEstimates = _f[1];
    var _g = useState([]), mergedEstimates = _g[0], setMergedEstimates = _g[1];
    var id = useParams().id;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    useEffect(function () {
        if (estimateId) {
            getEstimateAdditionalDetailByEstimateId();
        }
    }, []);
    var getEstimateAdditionalDetailByEstimateId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, _response$payload2, request, response, _response$payload3, _response$payload4, _response$payload5, _response$payload6, _response$payload7, _response$payload8, _response$payload9, OriginalEstimateData, originalEstimate_1, revisedEstimatesData, mergedEstimateData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        JobCardId: id ? id : jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "AllDataEstimate",
                            url: AllEstimateUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        setoriginalEstimate(response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.OriginalEstimate[0]);
                        OriginalEstimateData = [];
                        originalEstimate_1 = response !== null && response !== void 0 && (_response$payload4 = response.payload) !== null && _response$payload4 !== void 0 && (_response$payload4 = _response$payload4.value) !== null && _response$payload4 !== void 0 && _response$payload4.data && response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.value) !== null && _response$payload5 !== void 0 && _response$payload5.data.OriginalEstimate && Array.isArray(response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.data) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.OriginalEstimate) && response !== null && response !== void 0 && (_response$payload7 = response.payload) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.value) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.data) !== null && _response$payload7 !== void 0 && _response$payload7.OriginalEstimate[0] ? response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 || (_response$payload8 = _response$payload8.value) === null || _response$payload8 === void 0 || (_response$payload8 = _response$payload8.data) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.OriginalEstimate[0] : null;
                        if (originalEstimate_1) {
                            OriginalEstimateData = [originalEstimate_1];
                        }
                        setStatus(originalEstimate_1 === null || originalEstimate_1 === void 0 ? void 0 : originalEstimate_1.Key);
                        setEstimateCost((originalEstimate_1 === null || originalEstimate_1 === void 0 ? void 0 : originalEstimate_1.PartPrice) + (originalEstimate_1 === null || originalEstimate_1 === void 0 ? void 0 : originalEstimate_1.LabourPrice));
                        setLabourCost(originalEstimate_1 === null || originalEstimate_1 === void 0 ? void 0 : originalEstimate_1.LabourPrice);
                        setPartCost(originalEstimate_1 === null || originalEstimate_1 === void 0 ? void 0 : originalEstimate_1.PartPrice);
                        revisedEstimatesData = (response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.value) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.data) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.RevisedEstimate) || [];
                        setRevisedEstimates(revisedEstimatesData);
                        mergedEstimateData = [];
                        mergedEstimateData = __spreadArray(__spreadArray([], OriginalEstimateData, true), revisedEstimatesData, true);
                        setMergedEstimates(mergedEstimateData);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var approvedOrConvertedEstimates = mergedEstimates === null || mergedEstimates === void 0 ? void 0 : mergedEstimates.filter(function (item) { return item.Key !== "Error" && item.Key !== "Awaiting"; });
    var totalLabourPrice = approvedOrConvertedEstimates === null || approvedOrConvertedEstimates === void 0 ? void 0 : approvedOrConvertedEstimates.reduce(function (sum, item) { return sum + (isNaN(item === null || item === void 0 ? void 0 : item.LabourPrice) ? 0 : item.LabourPrice); }, 0);
    var totalPartPrice = approvedOrConvertedEstimates === null || approvedOrConvertedEstimates === void 0 ? void 0 : approvedOrConvertedEstimates.reduce(function (sum, item) { return sum + (isNaN(item === null || item === void 0 ? void 0 : item.PartPrice) ? 0 : item.PartPrice); }, 0);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: '100%',
        padding: 2
    }, !estimateId ? /*#__PURE__*/ React.createElement(Grid, {
        sx: {
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        p: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '16px',
        fontWeight: '500'
    }, "No data found !!")) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1,
        paddingY: 2,
        direction: 'row',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "Service estimate",
        variant: "h1"
    }, t("Service estimate")), /*#__PURE__*/ React.createElement(IconButton, {
        id: "BackArrowClick",
        onClick: onCrossClick
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "close",
        src: CrossIcon
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: "column",
        sx: {
            backgroundColor: "#C3CCD6",
            padding: "10px",
            borderRadius: "8px",
            marginTop: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: "space-between",
        sx: {
            marginBottom: '4px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontWeight: '600'
        }
    }, 'Approved total estimate'), /*#__PURE__*/ React.createElement(Typography, {
        id: "totalEstimate",
        variant: "body1",
        sx: {
            fontWeight: '600'
        }
    }, " ", RUPEES_SYMBOL, " ", isNaN(totalPartPrice + totalLabourPrice) ? '-' : (_ref = totalPartPrice + totalLabourPrice) === null || _ref === void 0 ? void 0 : _ref.toFixed(2))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            marginBottom: '8px'
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: "#1B1D21"
        }
    }, 'Parts'), /*#__PURE__*/ React.createElement(Typography, {
        id: "partsValue",
        variant: "body2",
        sx: {
            fontWeight: '600'
        }
    }, " ", RUPEES_SYMBOL, " ", isNaN(totalPartPrice) ? '0' : totalPartPrice === null || totalPartPrice === void 0 ? void 0 : totalPartPrice.toFixed(2), " ")), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: "#1B1D21"
        }
    }, 'Labors'), /*#__PURE__*/ React.createElement(Typography, {
        id: "labourValue",
        variant: "body2",
        sx: {
            fontWeight: '600'
        }
    }, " ", RUPEES_SYMBOL, " ", isNaN(totalLabourPrice) ? '0' : totalLabourPrice === null || totalLabourPrice === void 0 ? void 0 : totalLabourPrice.toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: "center",
        sx: {
            marginBottom: '8px',
            marginTop: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "8px"
        }
    }, originalEstimate.Key === "Approved" || originalEstimate.Key === "Converted" ? /*#__PURE__*/ React.createElement(CheckCircleIcon, {
        color: "primary",
        fontSize: "large"
    }) : /*#__PURE__*/ React.createElement(AdjustIcon, {
        color: "disabled",
        fontSize: "large"
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            width: "2px",
            height: "220px",
            backgroundColor: originalEstimate.Key === "Approved" || originalEstimate.Key === "Converted" ? "#3697FF" : "#DEE4EB",
            marginBottom: "4px"
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate",
        variant: "body1",
        sx: {
            fontWeight: '600'
        }
    }, 'Original estimate'), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: "#00C853",
            fontWeight: '600'
        },
        id: "priginal-estimate-part-price"
    }, " ", RUPEES_SYMBOL, " ", isNaN((originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.PartPrice) + (originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.LabourPrice)) ? '0' : ((originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.PartPrice) + (originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.LabourPrice)).toFixed(2))), /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-delivery-date",
        variant: "body2",
        sx: {
            color: "#8593A3"
        }
    }, "EDT: ", originalEstimate.DeliveryDate ? moment(originalEstimate.DeliveryDate).format('D MMM, YYYY - h:mmA') : "-"), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            padding: "10px",
            borderRadius: "8px",
            marginTop: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        display: "flex",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            fontWeight: '600',
            color: "#1B1D21"
        },
        id: "original-estimate-code"
    }, originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.SourceDocumentNo), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "6px",
            columnGap: "5px",
            padding: "10px 8px",
            height: "18px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        }
    }, /*#__PURE__*/ React.createElement(StatusColor, {
        status: originalEstimate.Key
    }), /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-name",
        sx: {
            width: 'max-content'
        },
        variant: "h6"
    }, originalEstimate.Key))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            marginTop: "5px",
            backgroundColor: "#F4F7FA",
            padding: "10px",
            borderRadius: "5px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: "#1B1D21"
        }
    }, "Total (parts)")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-total-parts-value",
        variant: "body1",
        sx: {
            color: "#1B1D21"
        }
    }, isNaN(originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.PartPrice) ? '0' : originalEstimate === null || originalEstimate === void 0 || (_originalEstimate$Par = originalEstimate.PartPrice) === null || _originalEstimate$Par === void 0 ? void 0 : _originalEstimate$Par.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: "#1B1D21"
        }
    }, "Total (labor)")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-total-labour-value",
        variant: "body1",
        sx: {
            color: "#1B1D21"
        }
    }, isNaN(originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.LabourPrice) ? '0' : originalEstimate === null || originalEstimate === void 0 || (_originalEstimate$Lab = originalEstimate.LabourPrice) === null || _originalEstimate$Lab === void 0 ? void 0 : _originalEstimate$Lab.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: '#DEE4EB',
            marginTop: "2px"
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            fontWeight: '600',
            color: "#1B1D21"
        }
    }, "Estimated cost")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-cost",
        variant: "h6",
        sx: {
            fontWeight: '600',
            color: "#1B1D21"
        }
    }, RUPEES_SYMBOL, " ", isNaN((originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.PartPrice) + (originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.LabourPrice)) ? '0' : ((originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.PartPrice) + (originalEstimate === null || originalEstimate === void 0 ? void 0 : originalEstimate.LabourPrice)).toFixed(2))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px",
        marginRight: "5px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: onViewClick
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "original-estimate-view-btn",
        style: {
            fontWeight: '400',
            fontSize: '16px',
            color: 'blue',
            cursor: 'pointer'
        }
    }, " ", t("View"), " ")))))), revisedEstimates.length > 0 && revisedEstimates.map(function (data, index) {
        var _data$PartPrice, _data$LabourPrice;
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 2,
            alignItems: "center",
            sx: {
                marginBottom: '8px'
            },
            key: index
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 1
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginRight: "8px"
            }
        }, data.Key === "Approved" ? /*#__PURE__*/ React.createElement(CheckCircleIcon, {
            color: "primary",
            fontSize: "large"
        }) : /*#__PURE__*/ React.createElement(AdjustIcon, {
            color: "disabled",
            fontSize: "large"
        }), /*#__PURE__*/ React.createElement("div", {
            style: {
                width: "2px",
                height: "195px",
                backgroundColor: data.Key === "Approved" ? "#3697FF" : "#DEE4EB",
                marginBottom: "4px"
            }
        }))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 11
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "revised-estimate",
            variant: "body1",
            sx: {
                fontWeight: '600'
            }
        }, 'Revised estimate'), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                color: "#00C853",
                fontWeight: '600'
            },
            id: "revised-estimate-part-price"
        }, " ", RUPEES_SYMBOL, " ", isNaN((data === null || data === void 0 ? void 0 : data.PartPrice) + (data === null || data === void 0 ? void 0 : data.LabourPrice)) ? '0' : ((data === null || data === void 0 ? void 0 : data.PartPrice) + (data === null || data === void 0 ? void 0 : data.LabourPrice)).toFixed(2))), /*#__PURE__*/ React.createElement(Typography, {
            id: "revised-delivery-date",
            variant: "body2",
            sx: {
                color: "#8593A3"
            }
        }, "EDT: ", data.DeliveryDate ? moment(data.DeliveryDate).format('D MMM, YYYY - h:mmA') : "-"), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            direction: "column",
            sx: {
                border: '1px solid #DEE4EB',
                padding: "10px",
                borderRadius: "8px",
                marginTop: '8px'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            display: "flex",
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            sx: {
                fontWeight: '600',
                color: "#1B1D21"
            },
            id: "revised-estimate-code"
        }, data === null || data === void 0 ? void 0 : data.SourceDocumentNo), /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: "center",
            sx: {
                border: "1px solid #DEE4EB",
                borderRadius: "6px",
                columnGap: "5px",
                padding: "10px 8px",
                height: "18px",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            }
        }, /*#__PURE__*/ React.createElement(StatusColor, {
            status: data === null || data === void 0 ? void 0 : data.Key
        }), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                width: 'max-content'
            },
            variant: "h6",
            id: "revised-status-name"
        }, data === null || data === void 0 ? void 0 : data.Key))), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                marginTop: "5px",
                backgroundColor: "#F4F7FA",
                padding: "10px",
                borderRadius: "5px"
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 1,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                color: "#1B1D21"
            }
        }, "Total (parts)")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            container: true,
            justifyContent: "flex-end"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "revised-total-parts-value",
            variant: "body1",
            sx: {
                color: "#1B1D21"
            }
        }, isNaN(data === null || data === void 0 ? void 0 : data.PartPrice) ? '0' : data === null || data === void 0 || (_data$PartPrice = data.PartPrice) === null || _data$PartPrice === void 0 ? void 0 : _data$PartPrice.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                color: "#1B1D21"
            }
        }, "Total (labor)")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            container: true,
            justifyContent: "flex-end"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "revised-total-labour-value",
            variant: "body1",
            sx: {
                color: "#1B1D21"
            }
        }, isNaN(data === null || data === void 0 ? void 0 : data.LabourPrice) ? '0' : data === null || data === void 0 || (_data$LabourPrice = data.LabourPrice) === null || _data$LabourPrice === void 0 ? void 0 : _data$LabourPrice.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                borderColor: '#DEE4EB',
                marginTop: "2px"
            }
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            sx: {
                fontWeight: '600',
                color: "#1B1D21"
            }
        }, "Estimated cost")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            container: true,
            justifyContent: "flex-end"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "revised-estimate-cost",
            variant: "h6",
            sx: {
                fontWeight: '600',
                color: "#1B1D21"
            }
        }, RUPEES_SYMBOL, " ", isNaN((data === null || data === void 0 ? void 0 : data.PartPrice) + (data === null || data === void 0 ? void 0 : data.LabourPrice)) ? '0' : ((data === null || data === void 0 ? void 0 : data.PartPrice) + (data === null || data === void 0 ? void 0 : data.LabourPrice)).toFixed(2))))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
            marginRight: "5px"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            onClick: function () {
                navigate("/reviseEstimate-details/RevisedEstimate/".concat(data === null || data === void 0 ? void 0 : data.id, "/").concat(data === null || data === void 0 ? void 0 : data.ParentId), {
                    state: {
                        fromRoute: window.location.pathname
                    }
                });
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            style: {
                fontWeight: '400',
                fontSize: '16px',
                color: 'blue',
                cursor: 'pointer'
            },
            id: "revised-estimate-view-btn"
        }, t("View")))))));
    })));
};
export default /*#__PURE__*/ memo(ServiceEstimateDrawer);
